import { GRID_LAYOUT } from '@scandipwa/scandipwa/src/route/CategoryPage/CategoryPage.config';
import { Suspense } from 'react';

import CategoryDetails from 'Component/CategoryDetails/CategoryDetails.component';
import CategoryDetailsBellow from 'Component/CategoryDetailsBellow';
import CategoryFilterApplied from 'Component/CategoryFilterApplied';
import CategoryProductList from 'Component/CategoryProductList';
import Icon from 'Component/Icon';
import {
    CategoryFilterOverlay,
    CategoryPage as SourceCategoryPage,
} from 'SourceRoute/CategoryPage/CategoryPage.component';
import { isCrawler, isSSR } from 'Util/Browser';

import './CategoryPage.override.style.scss';

export { CategoryFilterOverlay };

/** @namespace AdvoxBasic/Route/CategoryPage/Component/CategoryPage */
export class CategoryPage extends SourceCategoryPage {
    renderCategoryDetails() {
        const { category, isCurrentCategoryLoaded, isMatchingListFilter, totalItems } = this.props;

        return (
            <CategoryDetails
                category={category}
                isCurrentCategoryLoaded={isCurrentCategoryLoaded}
                isMatchingListFilter={isMatchingListFilter}
                totalItems={totalItems}
            />
        );
    }

    renderCategoryDetailsBellow() {
        const { category, isCurrentCategoryLoaded, totalItems, isSearchPage } = this.props;

        if (isSearchPage && totalItems === 0) {
            return null;
        }

        return <CategoryDetailsBellow category={category} isCurrentCategoryLoaded={isCurrentCategoryLoaded} />;
    }

    renderCategoryProductList() {
        const {
            filter,
            search,
            selectedSort,
            selectedFilters,
            isMatchingListFilter,
            isCurrentCategoryLoaded,
            isMatchingInfoFilter,
            isBrandPage,
        } = this.props;

        const { activeLayoutType } = this.state;

        if (!this.displayProducts()) {
            return null;
        }

        return (
            <div block="CategoryPage" elem="ProductListWrapper" mods={{ isPrerendered: isSSR() || isCrawler() }}>
                <CategoryProductList
                    filter={filter}
                    search={search}
                    sort={selectedSort}
                    selectedFilters={selectedFilters}
                    isCurrentCategoryLoaded={isCurrentCategoryLoaded}
                    isMatchingListFilter={isMatchingListFilter}
                    isMatchingInfoFilter={isMatchingInfoFilter}
                    layout={activeLayoutType || GRID_LAYOUT}
                    isBrandPage={isBrandPage}
                />
            </div>
        );
    }

    renderFilterButton() {
        const {
            isContentFiltered,
            totalPages,
            isMobile,
            isTablet,
            category: { is_anchor },
            isBrandPage,
        } = this.props;

        if (!isMobile && !isTablet) {
            return null;
        }

        if ((!isContentFiltered && totalPages === 0) || (!is_anchor && !isBrandPage)) {
            return null;
        }

        return (
            <button block="CategoryPage" elem="Filter" onClick={this.onFilterButtonClick}>
                <span>{`${__('Filters')}`}</span>
                {this.renderFiltersCount()}
                <Icon name="filters" />
            </button>
        );
    }

    renderPagination() {
        const {
            filter,
            search,
            selectedSort,
            selectedFilters,
            isMatchingListFilter,
            isCurrentCategoryLoaded,
            isMatchingInfoFilter,
            isBrandPage,
        } = this.props;

        const { activeLayoutType } = this.state;

        if (!this.displayProducts()) {
            return null;
        }

        return (
            <CategoryProductList
                filter={filter}
                search={search}
                sort={selectedSort}
                selectedFilters={selectedFilters}
                isCurrentCategoryLoaded={isCurrentCategoryLoaded}
                isMatchingListFilter={isMatchingListFilter}
                isMatchingInfoFilter={isMatchingInfoFilter}
                layout={activeLayoutType || GRID_LAYOUT}
                renderOnlyPagination
                isBrandPage={isBrandPage}
            />
        );
    }

    renderMiscellaneous() {
        const { totalItems } = this.props;

        if (totalItems === 0 || !this.displayProducts()) {
            return <aside block="CategoryPage" elem="Miscellaneous" mods={{ noResults: true }} />;
        }

        return (
            <aside block="CategoryPage" elem="Miscellaneous">
                <div block="CategoryPage" elem="LayoutWrapper" mods={{ isPrerendered: isSSR() || isCrawler() }}>
                    {this.renderCategorySort()}
                </div>
                {this.renderFilterButton()}
                {this.renderPagination()}
            </aside>
        );
    }

    renderFilterOverlay() {
        const { filters, selectedFilters, isMatchingInfoFilter, appliedFiltersCount, isBrandPage } = this.props;
        // eslint-disable-next-line fp/no-let
        let heading = __('Categories');

        if (isBrandPage) {
            heading = __('Manufacturers');
            delete filters.manufacturer;
        }

        const {
            category: { is_anchor },
        } = this.props;

        if (!this.displayProducts()) {
            return null;
        }

        return (
            <Suspense fallback={this.renderFilterPlaceholder()}>
                <CategoryFilterOverlay
                    availableFilters={filters}
                    customFiltersValues={selectedFilters}
                    isMatchingInfoFilter={isMatchingInfoFilter}
                    isCategoryAnchor={!!is_anchor}
                    appliedFiltersCount={appliedFiltersCount}
                    heading={heading}
                />
            </Suspense>
        );
    }

    renderFilterApplied() {
        const { filters, selectedFilters, isMatchingInfoFilter, isMobile, isTablet } = this.props;

        const {
            category: { is_anchor },
        } = this.props;

        if (!this.displayProducts() || isMobile || isTablet) {
            return null;
        }

        return (
            <section block="CategoryPage" elem="CategoryFilterApplied">
                <CategoryFilterApplied
                    availableFilters={filters}
                    customFiltersValues={selectedFilters}
                    isMatchingInfoFilter={isMatchingInfoFilter}
                    isCategoryAnchor={!!is_anchor}
                />
            </section>
        );
    }

    renderContent() {
        return (
            <>
                {this.renderFilterOverlay()}
                {this.renderCategoryDetails()}
                {this.renderFilterApplied()}
                {this.renderMiscellaneous()}
                {this.renderCmsBlock()}
                {this.renderCategoryProductList()}
                {this.renderCategoryDetailsBellow()}
            </>
        );
    }
}

export default CategoryPage;
